<template>
  <dialog-view
      :open="dataState.isModalOpen"
      :title="searchState.isModalOpen&&!userSearchMatch ? 'Поиск клиента' : searchState.isModalOpen&&userSearchMatch ? 'Найдено совпадение!' : userCreateState.isModalOpen ? 'Новый клиент' : ''"
      @cancel="close()"
      :cancelNotClose="!searchState.isInit"
  >
    <template v-slot:content>
      <div v-show="searchState.isModalOpen">
        <v-row v-if="searchState.isInit">
          <v-col v-if="visitCreateVisitPlan!==null" cols="12">
            <v-sheet rounded outlined class="pa-4">
              <div>Создать визит из {{ visitCreateVisitPlan.isLiveList? 'листа живой очереди' : 'листа ожидания'}}?</div>
              <div>Клиент: {{visitCreateVisitPlan.user.lastName}} {{visitCreateVisitPlan.user.firstName}} {{visitCreateVisitPlan.user.secondName}}</div>
              <div class="mt-2">
                <v-btn small depressed class="mr-2" @click="visitCreateVisitPlan=null;close()">Отмена</v-btn>
                <v-btn small depressed color="primary" @click="userSelected(visitCreateVisitPlan.user, visitCreateVisitPlan.id)">Создать</v-btn>
              </div>
            </v-sheet>
          </v-col>
          <v-col v-if="visitMove!==null" cols="12">
            <v-sheet rounded outlined class="pa-4">
              <div>Перенести визит c {{$tools.dateTimeFormat(visitMove.begin, 'DD.MM.YYYY HH:mm')}}<br/>на {{$tools.dateTimeFormat(begin, 'DD.MM.YYYY HH:mm')}}?</div>
              <div>Клиент: {{visitMove.user.lastName}} {{visitMove.user.firstName}} {{visitMove.user.secondName}}</div>
              <div class="mt-2">
                <p class="caption my-3">Выберите длительность приёма:</p>
                <v-btn small depressed color="primary mb-3" @click="$emit('visitMove', visitMove)">Перенести (по шагу приёма)</v-btn>
                <v-btn small depressed color="primary" @click="$emit('visitMove', visitMove, true)">Перенести (по длительности визита)</v-btn>
              </div>

              <v-btn small depressed class="mt-4" @click="visitMove=null;close()">Отмена</v-btn>
            </v-sheet>
          </v-col>
          <v-col cols="12">
            Укажите номер телефона пациента или Ф.И.О
          </v-col>
          <v-col cols="12">
              <phone-field ref="phone" :phone.sync="phone" label="Телефон" @enterPressed="$tools.focusNext('s-input1',$refs)"/>
          </v-col>
          <v-col cols="12">
            <v-text-field
                @input="searchLastName = $tools.capitalizeName($event)"
                v-model="searchLastName"
                dense clearable label="Фамилия" outlined hide-details="auto"
                ref="s-input1" @keydown.enter="$tools.focusNext('s-input2',$refs)"/>
          </v-col>
          <v-col cols="12">
            <v-text-field
                @input="searchFirstName = $tools.capitalizeName($event)"
                v-model="searchFirstName"
                dense clearable label="Имя" outlined hide-details="auto"
                ref="s-input2" @keydown.enter="$tools.focusNext('s-input3',$refs)"/>
          </v-col>
          <v-col cols="12">
            <v-text-field
                @input="searchSecondName = $tools.capitalizeName($event)"
                v-model="searchSecondName"
                dense clearable label="Отчество" outlined hide-details="auto"
                ref="s-input3"/>
          </v-col>
        </v-row>
        <div v-if="searchState.isLoading" class="py-4 text-center">
          <v-progress-circular indeterminate color="primary"/>
        </div>
        <div v-if="searchState.isSuccess">
          <div v-if="searchUsers.length>0">
            <v-list class="pa-0 ma-n4">
              <v-list-item v-for="(item, index) in searchUsers" :key="index" link @click="userSelected(item)">
                <v-list-item-title class="py-2">
                  <h3 class="font-weight-regular mb-2">{{item.lastName}} {{item.firstName}} {{item.secondName}}</h3>
                  <div class="font-weight-regular">
                    <span class="mr-4"><v-icon class="mr-2" small>mdi-account-outline</v-icon>{{item.userProfile.gender==='male' ? 'Мужчина' : 'Женщина'}}</span>
                    <span class="mr-4"><v-icon class="mr-2" small>mdi-calendar-star</v-icon>{{item.userProfile.birth|date}}</span>
                    <span><v-icon class="mr-2" small>mdi-phone-outline</v-icon>{{item.phone}}</span>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
          <div v-else>
            <alert-view icon="mdi-information-outline" text="Не найдено" />
          </div>
        </div>
      </div>
      <v-form v-show="userCreateState.isModalOpen" ref="userCreateForm">
        <v-row>
          <v-col cols="12">
            <v-text-field @input="userCreateLastName = $tools.capitalizeName($event)" v-model="userCreateLastName" label="Фамилия" :rules="formFieldRules.required" outlined dense hide-details="auto" ref="input1" @keydown.enter="$tools.focusNext('input2',$refs)"/>
          </v-col>
          <v-col cols="12">
            <v-text-field @input="userCreateFirstName = $tools.capitalizeName($event)" v-model="userCreateFirstName" label="Имя" :rules="formFieldRules.required" outlined dense hide-details="auto" ref="input2" @keydown.enter="$tools.focusNext('input3',$refs)"/>
          </v-col>
          <v-col cols="12">
            <v-text-field @input="userCreateSecondName = $tools.capitalizeName($event)" v-model="userCreateSecondName" label="Отчество" outlined dense hide-details="auto" ref="input3" @keydown.enter="$tools.focusNext('input4',$refs)"/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="userCreateGender" :items="[{name:'Женщина', value:'female'},{name:'Мужчина', value:'male'}]" item-text="name" item-value="value" label="Пол" outlined dense hide-details="auto"/>
          </v-col>
          <v-col cols="12">
            <simple-date-view :date.sync="userCreateBirth" title="Дата рождения" required ref="input4" @enterPressed="$tools.focusNext('input5',$refs)"/>
          </v-col>
          <v-col cols="12">
            <phone-field :phone.sync="phone" label="Телефон" required ref="input5"/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="userCreatePromoSource" :rules="formFieldRules.required" :items="promoSources" :loading="promoSourcesState.isLoading" item-text="name" item-value="id" label="Рекламный источник" outlined dense hide-details="auto"/>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <div v-if="searchState.isModalOpen">
        <div v-if="searchState.isInit">
          <v-btn @click="search()" color="primary" text>Поиск</v-btn>
        </div>
        <div v-if="searchState.isSuccess">
          <v-btn v-if="!userSearchMatch"
            @click="
              searchState.modalClose();
              userCreateState.modalOpen();
              userCreateState.stateInit();
              userCreateLastName=searchLastName?.trim();
              userCreateFirstName=searchFirstName?.trim();
              userCreateSecondName=searchSecondName?.trim();
              $refs.userCreateForm.resetValidation();
            " color="primary" text
          >Новый клиент</v-btn>


        <btn-question v-if="userSearchMatch" @click="userCreate(true)" :loading="userCreateState.isLoading"  color="primary" text  size="default" class="mr-2" title="Создать нового клиента?">
          <template v-slot:default>Создать</template>
          <template v-slot:content>
              <div class="mx-5 my-5">
                <v-alert
                  outlined
                  type="warning"
                  prominent
                  border="left"
                >
                Было найдено совпадение, Вы уверены, что хотите создать нового пользователя?
                </v-alert>
              </div>
          </template>
        </btn-question>
        </div>
      </div>
      <div v-if="userCreateState.isModalOpen">
        <v-btn @click="userCreate()" color="primary" text :loading="userCreateState.isLoading">Создать</v-btn>
      </div>
    </template>
  </dialog-view>
</template>


<script>
import State from "@/plugins/state";
import DialogView from "@/components/DialogView";
import {FormFieldRules} from "@/plugins/formFieldRules";
import moment from "moment";
import axios from "axios";
import Api from "@/Api";
import AlertView from "@/components/AlertView";
import PhoneField from "@/components/PhoneField";
import BtnQuestion from "@/components/btnQuestion.vue";
import SimpleDateView from "@/components/SimpleDateView";

export default {
  components: {AlertView, DialogView, PhoneField, BtnQuestion, SimpleDateView},
  props:['state','dataFromCaller','visitMode'],
  data: () => ({
    dataState: new State(),
    formFieldRules: FormFieldRules,

    begin:null,
    end:null,
    comPlaceId:null,

    searchState: new State(),
    phone:null,
    searchFirstName:null,
    searchLastName:null,
    searchSecondName:null,
    searchUsers:[],
    visitCreateVisitPlan:null,
    visitMove:null,

    userCreateState: new State(),
    userCreateLastName:null,
    userCreateFirstName:null,
    userCreateSecondName:null,
    userCreateGender:null,
    userCreateBirth:null,
    userCreatePromoSource:undefined,

    promoSourcesState: new State(),
    promoSources:[],

    birthYear:null,
    userSearchMatch:false,
   
  }),
  watch:{
    state: {
      deep: true,
      handler() {
        if(this.state.isModalOpen){
          this.resetData();

          this.promoSourcesLoad();
          this.dataState.modalOpen();

          this.visitCreateVisitPlan = this.state.modalData?.visitCreateVisitPlan||null;
          this.visitMove = this.state.modalData?.visitMove||null;
       
          if (this.dataFromCaller?.user !== undefined) {
            this.dataState.modalClose();
            this.userSelected(this.dataFromCaller.user, null, this.dataFromCaller.visitServices)
          } else {


    
            if (!this.dataFromCaller) {
              this.searchState.modalOpen();
              this.searchState.stateInit();
 
              setTimeout(()=>{
                if(this.$refs.phone.$el)
                  this.$refs.phone.$el.querySelector('input').focus();
              }, 200);
            }
            
            if (this.dataFromCaller?.phone!==undefined){
              this.searchState.stateSuccess();
              this.userCreateState.modalOpen();
              this.userCreateState.stateInit();
              
              this.phone = this.dataFromCaller.phone
       
            } 
          }
        } else {
          this.resetData();
        }
      },
    },
    userCreateSecondName(v){
      this.userCreateGender = this.$tools.getGenderBySecondName(v);
    }
  },
  methods: {
    resetData() {
      this.dataState.modalClose();
      this.searchState = new State()
      this.userCreateState = new State()

      this.phone=null;

      this.searchFirstName=null;
      this.searchLastName=null;
      this.searchSecondName=null;
      this.searchUsers = [];

      this.userCreateLastName = null;
      this.userCreateFirstName = null;
      this.userCreateSecondName = null;
      this.userCreateGender = null;
      this.userCreateBirth = null;
      this.userCreatePromoSource = undefined;

      this.userSearchMatch = false;
      this.visitCreateVisitPlan = null;
      this.visitMove = null;
    },
    search(matchCheck=false){
      this.searchState.stateLoading();
      this.userSearchMatch = false;

      let params = {};   
      if(!this.$tools.isEmpty(this.phone))
        if(this.phone.length>2) params.phone = this.phone;
      if(!this.$tools.isEmpty(this.searchFirstName)) params.firstName = this.searchFirstName?.trim();
      if(!this.$tools.isEmpty(this.searchLastName)) params.lastName = this.searchLastName?.trim();
      if(!this.$tools.isEmpty(this.searchSecondName)) params.secondName = this.searchSecondName?.trim();

      
      axios.get(Api.host+'/user/?filters='+JSON.stringify(params)+'&sortBy=lastName').then((r)=> {
        this.searchUsers = r.data.data;
        this.searchState.stateSuccess();

        if(matchCheck&&this.searchUsers.length>0) {
          this.userSearchMatch = true;
          this.userCreateState.modalClose();
          this.searchState.modalOpen();
        } else if (matchCheck&&this.searchUsers.length===0) {
          this.userCreate(true);
        }
      })
      .catch(()=>{
        this.searchState.stateError();
      });
    },
    promoSourcesLoad(){
      this.promoSourcesState.stateLoading();
      axios.get(Api.host+'/user/promoSource/')
        .then(r=> {
          this.promoSources = r.data;
          this.promoSourcesState.stateSuccess();
        })
        .catch(e=>{
          this.promoSourcesState.stateError();
          console.log(e)
        });
    },

    userSelected(user, visitPlanId=null, visitServices=[]) {
      this.$emit('userSelected',user,visitPlanId,visitServices)
    },
    userCreate(forced=false) {
      if (this.$refs.userCreateForm.validate()) {
        if (!forced) {
          // проверка перед созданием на совпадение по ФИО
          this.searchFirstName=this.userCreateFirstName?.trim();
          this.searchLastName=this.userCreateLastName?.trim();
          this.searchSecondName=this.userCreateSecondName?.trim();

          this.search(true);
        }
        if (this.searchUsers.length===0||forced===true) {

          if (this.visitMode!==undefined) {
            const userData = {
              userPhone: this.phone,
              userFirstName: this.userCreateFirstName?.trim(),
              userLastName: this.userCreateLastName?.trim(),
              userSecondName: this.userCreateSecondName?.trim(),
              userProfileGender: this.userCreateGender,
              userProfileBirth: this.userCreateBirth ? moment(this.userCreateBirth).format('YYYY-MM-DD') : null,
              userProfilePromoSource: this.userCreatePromoSource
            }

            this.$emit('userCreate',userData) 

          } else {
            axios.post(Api.host+'/user/', {
              type: 'client',
              phone: this.phone,
              firstName: this.userCreateFirstName?.trim(),
              lastName: this.userCreateLastName?.trim(),
              secondName: this.userCreateSecondName?.trim(),
              userProfile:{
                gender: this.userCreateGender,
                birth: this.userCreateBirth ? moment(this.userCreateBirth).format('YYYY-MM-DD') : null,
                promoSource: this.userCreatePromoSource
              }
            })
            .then((r)=> {
              this.userCreateState.stateSuccess();
              this.userCreateState.modalClose();
              this.dataState.modalClose();
              this.$emit('userCreate',r.data)
            })
            .catch(function (error) {
              this.userCreateState.stateError();
              console.log(error)
            });
          }
        }
      }
    },
    close(){
      if(this.userCreateState.isModalOpen) {
        this.userCreateState.modalClose();
        this.searchState.modalOpen();
        this.searchState.stateSuccess();
      } else if(this.searchState.isModalOpen) {
        if(this.searchState.isSuccess){
          this.searchState.stateInit();
        } else{
          this.dataState.modalClose();
          this.$emit('cancel');
        }
      }
      this.userSearchMatch = false;
    }
  }
}
</script>